// extracted by mini-css-extract-plugin
export var column = "MultiImageBlock-module--column--7e88b";
export var flexReverse = "MultiImageBlock-module--flexReverse--0ced9";
export var image = "MultiImageBlock-module--image--208de";
export var imageCol = "MultiImageBlock-module--imageCol--5cb3e";
export var imageColFull = "MultiImageBlock-module--imageColFull--36fb1";
export var imageContainer = "MultiImageBlock-module--imageContainer--b4f29";
export var imageGroup = "MultiImageBlock-module--imageGroup--21e4d";
export var imageRow = "MultiImageBlock-module--imageRow--46924";
export var oneQuarter = "MultiImageBlock-module--oneQuarter--b4a59";
export var oneThird = "MultiImageBlock-module--oneThird--86646";
export var photoCredit = "MultiImageBlock-module--photoCredit--c8ca7";
export var threeQuarters = "MultiImageBlock-module--threeQuarters--35597";
export var twoThirds = "MultiImageBlock-module--twoThirds--14d4d";